import { loadAuthState } from '../../auth/state.js';

export function getToken(): string | null {
  const authState = loadAuthState();
  return authState.user ? (authState.user.get('token') ?? null) : null;
}
